// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3kEEa","footer":"ModalUpdate_footer__26nAM"};